// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"956827fc","442":"0aa338db","829":"05e4bd19","963":"6d793593","999":"cc73148a"}[chunkId] + ".chunk.js";
};